import { ComponentIds } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import { PlannerEcsSystem, RangeComponent } from '../../..';
export class LegSelectionSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'LegSelectionSystem', ComponentIds.SELECTED_COMPONENT_ID);
    }
    onAdd(entity) {
        if (entity.hasComponent(ComponentIds.LEG_COMPONENT_ID)) {
            this.outlineAllLegs(entity);
        }
    }
    onUpdate() { }
    onRemove() {
        this.removeAllOutlines();
    }
    outlineAllLegs(selectedLeg) {
        const selectedLegRange = selectedLeg.getComponent(RangeComponent.id)?.range;
        const legs = this.coreApi.entities.getByComponent(ComponentIds.LEG_COMPONENT_ID, selectedLegRange);
        legs.forEach(leg => {
            leg.addComponent(new OutlinedComponent());
        });
    }
    removeAllOutlines() {
        const legs = this.coreApi.entities.getByComponent(ComponentIds.LEG_COMPONENT_ID);
        legs.forEach(leg => {
            leg.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        });
    }
}
//# sourceMappingURL=LegSelectionSystem.js.map